
import {Routes} from 'constants/index';
import {navigate} from 'gatsby';
import {omit} from 'lodash';
import {cookies, CookKey} from 'utils/cookies';

import {RenewInterval} from './query/types';
import {CheckoutReason, QueryVars} from './store/types.query';

export const setupStore = (vars: QueryVars, replace?: boolean) => {
	const data = JSON.stringify(vars);
	cookies.set(CookKey.Checkout, data);
	navigate(Routes.checkoutPayment, {
		replace,
	});
};

const getReferrer = () => {
	const referrer = cookies.get(CookKey.Referrer);
	return referrer ? {referrer} : {};
};

export const createReserveAppt = (values: {
	appt: string,
	hold: string,
	interval?: RenewInterval,
	quantity: number,
	redirect: string,
}): QueryVars => {
	return {
		configs: {
			reason: CheckoutReason.reserveAppt,
			redirect: values.redirect,
		},
		intent: '',
		...omit(values, [
			'redirect',
		]),
		...getReferrer(),
	};
};

export type PurchaseVars = {
	product: string,
	discount?: string,
	interval?: RenewInterval,
	quantity: number,
	redirect: string,
};

export const createPurchase = (values: PurchaseVars): QueryVars => {
	return {
		configs: {
			reason: CheckoutReason.purchase,
			redirect: values.redirect,
		},
		intent: '',
		...omit(values, [
			'redirect',
		]),
		...getReferrer(),
	};
};

